import React, { useEffect, useState, useRef } from "react";
import { useLocation, Link, useParams } from "react-router-dom";
import { getDiscountedProducts } from "../Services/Service";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { BottomSheetCustom } from "@cred/neopop-web/lib/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCartShopping,
  faSliders,
  faArrowDownWideShort,
} from "@fortawesome/free-solid-svg-icons";
import {
  getHistory,
  addedToCart as adds,
  search_result,
} from "../Services/Service";
const DiscountProduct = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const discount = queryParams.get("discount");

  const [issOpen, setIssOpen] = useState();

  const [vendorId, setVendorId] = useState("categoryId");
  const [category, setCategory] = useState("");
  const [toggleViewMode, setToggleViewMode] = useState(
    sessionStorage.getItem("view") === "true" ? true : false
  );
  const limit = 5;

  const useElementOnScreen = (options) => {
    const intRef = useRef(null);
    const [isVisible, setVisible] = useState([]);
    const isLoadingMore = useRef(false); // Prevent multiple simultaneous API calls
    const callbackFunction = (entries) => {
      const [entry] = entries;
      // console.log(entry);
      if (entry.isIntersecting) {
        // Check if we should load more: not already loading, have more to load, and not at the end
        if (!isLoadingMore.current && products.length < total && products.length > 0) {
          isLoadingMore.current = true;
          setLoading(true);
          let page = Math.ceil(products.length / limit) + 1;
          // let x  = ""
          // if(location.state){
          //   x=location.state
          // }else{
          //   x="categoryId"
          // }
          getHistory(limit, page, vendorId, catId, sortBy)
            .then((res) => {
              // Check if API returned no products (status 0 or empty data array)
              if (res.data.status === 0 || !res.data.data || res.data.data.length === 0) {
                // No more products available - update total to current length to stop further requests
                setTotal(products.length);
                setLoading(false);
                isLoadingMore.current = false;
                return;
              }
              
              // Update total if provided in response
              if (res.data.total !== undefined) {
                setTotal(res.data.total);
              }
              
              // console.log(res.data);
              setCategory(res.data.category);
              return res;
            })
            .then((res) => {
              // Only merge if we have data (res might be undefined if no products found)
              if (res && res.data?.data && res.data.data.length > 0) {
                const mergeData = [...products, ...res.data.data];
                setProducts(mergeData);
              }
              setLoading(false);
              isLoadingMore.current = false;
            })
            .catch((err) => {
              console.log(err.message);
              setLoading(false);
              isLoadingMore.current = false;
              // On error, update total to prevent infinite loop
              setTotal(products.length);
            });
        }
      }
      setVisible(entry.isIntersecting);
    };

    useEffect(() => {
      const observer = new IntersectionObserver(callbackFunction, options);
      if (intRef.current) observer.observe(intRef.current);

      return () => {
        if (intRef.current) observer.unobserve(intRef.current);
      };
    }, [intRef, options]);
    return [intRef, isVisible];
  };

  const [intRef, isVisible] = useElementOnScreen({
    root: null,
    rootMargin: "0px",
    threshold: 1.0,
    triggerOnce: true,
  });
  const [total, setTotal] = useState(0);
  const [sortBy, setSortBy] = useState("DiscountDESC");
  const [sortBys, setSortBys] = useState("DiscountDESC");
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // ✅ Function moved outside useEffect
  const fetchDiscountedProducts = async (discountValue) => {
    if (!discountValue) {
      setError("No discount parameter provided.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await getDiscountedProducts(discountValue);
      setTotal(response?.data?.total);
      setProducts(response?.data?.data);
    } catch (err) {
      setError("Failed to load discounted products. Please try again.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDiscountedProducts(discount);
  }, [discount]);

  const isDiscount = "true";
  let { catId } = useParams();

  // console.log(products, "products");
  return (
    <div className="content-apps">
      <HelmetProvider>
        <Helmet>
          <title>Today's Deal</title>
        </Helmet>
      </HelmetProvider>

      <div className="circleblurbg"></div>
      <BottomSheetCustom
        open={issOpen}
        handleClose={() => setIssOpen(!issOpen)}
      >
        <div
          className="sd-body mb-5 pb-4"
          style={{ borderRadius: "32px 32px 0 0" }}
        >
          <div className="bottomPopupInner bg-grey fixPos bottomPopupInner-enter-done">
            <div className="pheader">Sort by</div>
            <div className="pContainer" onClick={() => setIssOpen(false)}>
              <ul>
                <li
                  className=""
                  onClick={() => {
                    setLoading(true);
                    setSortBy("PriceASC");
                    setSortBys("PriceASC");
                  }}
                >
                  <a
                    href="#"
                    className={sortBy === "PriceASC" ? "font-16s" : "font-16"}
                  >
                    Price Low to High
                  </a>
                </li>
                <li
                  className=""
                  onClick={() => {
                    setLoading(true);
                    setSortBy("PriceDESC");
                    setSortBys("PriceDESC");
                  }}
                >
                  <a
                    href="#"
                    className={sortBy === "PriceDESC" ? "font-16s" : "font-16"}
                  >
                    Price High to Low
                  </a>
                </li>
                <li
                  className=""
                  onClick={() => {
                    setLoading(true);
                    setSortBy("DiscountASC");
                    setSortBys("DiscountASC");
                  }}
                >
                  <a
                    href="#"
                    className={
                      sortBy === "DiscountASC" ? "font-16s" : "font-16"
                    }
                  >
                    Discounts Low to High
                  </a>
                </li>
                <li
                  className=""
                  onClick={() => {
                    setLoading(true);
                    setSortBy("DiscountDESC");
                    setSortBys("DiscountDESC");
                  }}
                >
                  <a
                    href="#"
                    className={
                      sortBy === "DiscountDESC" ? "font-16s" : "font-16"
                    }
                  >
                    Discounts High to Low
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div style={{ visibility: "hidden" }}>hello</div>
      </BottomSheetCustom>

      <div className="plpFilterSec">
        <div className="container-fluid">
          <div className="product-filter">
            <div className="row">
              <div className="col-6">
                <button
                  className="product-filter-btn side-line"
                  onClick={() => {
                    sessionStorage.setItem("view", !toggleViewMode);
                    setToggleViewMode(!toggleViewMode);
                  }}
                >
                  <span>
                    <i
                      className={
                        toggleViewMode
                          ? "plpFotGridIcon text-white-50"
                          : "plpFotListIcon text-white-50"
                      }
                    ></i>
                  </span>
                </button>
              </div>
              <div className="col-6">
                <button
                  className="product-filter-btn text-white-50"
                  onClick={() => setIssOpen(true)}
                >
                  <span>
                    Sort by{" "}
                    <FontAwesomeIcon
                      icon={faArrowDownWideShort}
                      className="text-white-50"
                    />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {loading && (
        <div className="text-center my-4">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      {error && <div className="alert alert-danger mt-3">{error}</div>}

      {!loading && !error && products.length === 0 && (
        <div className="text-muted mt-3">No discounted products found.</div>
      )}

      {/* {!loading && !error && products.length > 0 && (
        <ul className="list-group mt-3">
          {products.map((product) => (
            <li className="list-group-item" key={product.id}>
              <strong>{product.productTitle}</strong> - ₹{product.offerPrice}
            </li>
          ))}
        </ul>
      )} */}

      <div className="container">
        <div className="product-list mt-1">
          <div className="row">
            {total < 5 ? (
              <div className="limited-deal-container d-flex justify-content-center  ">
                <div className="deal-alert">
                  <div className="deal-content">
                    <span className="alert-icon">🔥</span>
                    <span className="deal-text">
                      100% OFF TODAY! Only{" "}
                      <span className="deals-count">{total}</span> left
                    </span>
                  </div>
                </div>
              </div>
            ) : (
              <div className="d-flex justify-content-center">
                <h2>Todays Deal</h2>
              </div>
            )}

            {products?.map((item, i) => (
              <div
                className={`mb-4 ${
                  !toggleViewMode ? "col-12" : "col-6 col-md-4 col-lg-3 "
                }`}
                key={item.productId}
              >
                <Link to={`/productdetails/${item.productId}?deal=${discount}`}>
                  <div className="card h-100 p-1 relative">
                    <div
                      className=" row align-items-center"
                      style={{ marginLeft: !toggleViewMode ? "0" : "-14px" }}
                    >
                      <div
                        className={`${
                          !toggleViewMode
                            ? "col-5 col-lg-2 p-0 ps-md-2"
                            : "col-12"
                        }`}
                      >
                        <div className="card-image ">
                          <img
                            className="img-fluid rounded"
                            src={item.productImage}
                            alt=""
                          />
                        </div>
                      </div>
                      <div
                        className={`${
                          !toggleViewMode ? "col-7 col-lg-10 p-0" : "col-12"
                        }`}
                      >
                        <div className="card-body">
                          <h1 className="product-name">{item.productTitle}</h1>
                          <p className="flash-sale m-0">
                            <span>
                              MRP &nbsp;{" "}
                              <span style={{ textDecoration: "line-through" }}>
                                {" "}
                                ₹ {item.productPrice}&nbsp;{" "}
                              </span>{" "}
                            </span>

                            {(catId !== "S2tZZ1VtaWxsSFJHQ1B0M1RadXhoZz09" ||
                              vendorId === "vendorId") && (
                              <span style={{ color: "green" }}>
                                {item.maxRewardPointRedemptionPercentage}% Off
                              </span>
                            )}
                          </p>
                          <p className="text-success m-0 ">{item.discount}</p>
                          {catId === "S2tZZ1VtaWxsSFJHQ1B0M1RadXhoZz09" &&
                            vendorId !== "vendorId" && (
                              <span
                                style={{ color: "green", fontSize: "15px" }}
                              >
                                upto ₹ {item.rangeMax}
                              </span>
                            )}
                          <p className="product-price-off ">
                            {!toggleViewMode ? "You Pay:" : "Pay:"}{" "}
                            {item.spicegold !== 0 ? (
                              <>
                                <span className="t-red">
                                  <span
                                    style={{
                                      fontWeight: "normal",
                                      color: "white",
                                    }}
                                  >
                                    ₹ {item.offerPrice} +
                                  </span>{" "}
                                  <span style={{ color: "red" }}>
                                    {item.spicegold}
                                  </span>{" "}
                                  Sg{" "}
                                  <img
                                    src={"/assets/images/spicegold.png"}
                                    alt=""
                                    style={{ height: "20px", width: "20px" }}
                                  />
                                </span>
                              </>
                            ) : (
                              <>
                                <span className="t-red">
                                  <span
                                    style={{
                                      fontWeight: "normal",
                                      color: "white",
                                    }}
                                  >
                                    ₹ {item.offerPrice} +
                                  </span>{" "}
                                  <img
                                    src={"/assets/images/spicegold.png"}
                                    alt=""
                                    style={{
                                      height: "20px",
                                      width: "20px",
                                      marginBottom: "2.5px",
                                    }}
                                  />{" "}
                                  {0} &nbsp;
                                </span>
                              </>
                            )}
                          </p>
                          {/* <div
                            className="d-flex justify-content-end"
                            style={{
                              // position: "absolute",
                              top: "5px",
                              right: "5px",
                              zIndex: 10,
                              animation: "pulseBadge 1.5s infinite",
                              transform: "rotate(-3deg)",
                            }}
                          >
                            <div
                              className="text-white px-2 py-1"
                              style={{
                                background:
                                  "linear-gradient(45deg, #FFA500, #FF6347)",
                                borderRadius: "12px",
                                fontWeight: "bold",
                                fontSize: "0.8rem",
                                boxShadow: "0 0 6px rgba(0, 0, 0, 0.2)",
                                whiteSpace: "nowrap",
                              }}
                            >
                              ⚡ {item.productStock} left in stock!
                            </div>
                          </div> */}
                          <div
                            className="d-flex justify-content-start"
                            style={{
                              top: "5px",
                              right: "5px",
                              zIndex: 10,
                              animation: "pulseStockText 2s infinite",
                              transform: "rotate(-2deg)",
                            }}
                          >
                            <span
                              style={{
                                color: "#FF3B30", // red for urgency
                                fontSize: "0.8rem",
                                fontWeight: "500",
                                backgroundColor: "rgba(255, 59, 48, 0.1)",
                                padding: "2px 6px",
                                borderRadius: "6px",
                              }}
                            >
                              ⚡ Only {item.productStock} left!
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
          <div ref={intRef}>
            <p style={{ paddingBottom: "20px" }}>
              {products.length < total ? "Loading..." : "No more products"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiscountProduct;
